import {
  ORDERS_INFO_GET,
  ASC_DATE_FILTER,
  DESC_DATE_FILTER,
  ASC_NUMBER_FILTER,
  DESC_NUMBER_FILTER,
  ORDER_STATUS_UPDATE,
  ORDER_LAST_DOCUMENT_SAVE
} from "./mutation-types";

export default {
  [ORDERS_INFO_GET](state, data) {
    if (data.keepPrevios) {
      state.pedidos = state.pedidos.concat(data.pedidos);
      state.totalResults += data.totalResults;
    } else {
      state.pedidos = data.pedidos;
      state.totalResults = data.totalResults;
    }
  },
  [ASC_DATE_FILTER](state) {
    state.pedidos.sort(function(a, b) {
      if (a.date > b.date) {
        return 1;
      }
      if (a.date < b.date) {
        return -1;
      }
      return 0;
    });
  },
  [DESC_DATE_FILTER](state) {
    state.pedidos.sort(function(a, b) {
      if (a.date < b.date) {
        return 1;
      }
      if (a.date > b.date) {
        return -1;
      }
      return 0;
    });
  },
  [ASC_NUMBER_FILTER](state) {
    state.pedidos.sort(function(a, b) {
      if (a.id > b.id) {
        return 1;
      }
      if (a.id < b.id) {
        return -1;
      }
      return 0;
    });
  },
  [DESC_NUMBER_FILTER](state) {
    state.pedidos.sort(function(a, b) {
      if (a.id < b.id) {
        return 1;
      }
      if (a.id > b.id) {
        return -1;
      }
      return 0;
    });
  },
  [ORDER_STATUS_UPDATE](state, status) {
    state.orderStatus = status;
  },
  [ORDER_LAST_DOCUMENT_SAVE](state, lastDocument) {
    state.lastDocument = lastDocument;
  }
};
